import React from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { TeamAdmin, ContainerSecuritySettings, useAuth } from "@byscott-io/corebyscott";
import { BillingPortal } from "@byscott-io/billingbyscott_client";

const tabs = [
  { id: "team", label: "Team" },
  { id: "security", label: "Security" },
  { id: "billing", label: "Billing" },
];

export default function AdminPage() {
  const { tab = "team", section } = useParams();
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Admin</h1>
        <p className="text-gray-500">Manage your app settings</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex gap-8">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => navigate(`/app/admin/${t.id}`)}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                tab === t.id
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {tab === "team" && <TeamAdmin />}
        {tab === "security" && <ContainerSecuritySettings />}
        {tab === "billing" && <BillingPortal initialTab={section} />}
      </div>
    </div>
  );
}
